<template>
    <div class="modal-confirm">
        <p class="modal-confirm__message">{{ message }}</p>
        <div class="modal-confirm__actions">
            <button 
                v-for="(option, index) in options"
                @click="handleClick(option.handler, option.args, event)"
                :class="option.classList"
            >
                {{ option.text }}
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        componentProps: Object,
    },
    created() {
        Object.keys(this.componentProps).forEach(key => {
            this[key] = this.componentProps[key]
        })
    },
    methods: {
        handleClick: function(handler, args) {
            handler(args)
        }
    }
};

</script>
<style>
    .modal-confirm__message {
        max-width: 60ch;
        font-size: var(--font-size-4);
        margin-bottom: var(--grid-gap);
    }

    .modal-confirm__actions {
        display: flex;
        justify-content: flex-end;
    }

    .modal-confirm__actions button + button {
        margin-left: var(--grid-gap);
    }
</style>
